export type JourneyRouteSurface = 'public_landing' | 'detail' | 'learn';

const UUID_RE = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

export function normalizeTrackingPath(path: string): string {
  const pathname = path.split(/[?#]/)[0] || '/';
  return pathname.replace(/\/+$/, '') || '/';
}

export function getJourneyRouteSurface(path: string): JourneyRouteSurface | null {
  const normalizedPath = normalizeTrackingPath(path);

  if (/^\/j\/[^/]+$/.test(normalizedPath)) {
    return 'public_landing';
  }

  if (/^\/journey\/[^/]+\/learn$/.test(normalizedPath)) {
    return 'learn';
  }

  if (/^\/journey\/[^/]+$/.test(normalizedPath)) {
    return 'detail';
  }

  return null;
}

export function isJourneyManagedTrackingRoute(path: string): boolean {
  return getJourneyRouteSurface(path) !== null;
}

/** Navigation intent suppresses telemetry; the route boundary verifies access. */
export function isCourseWritingPreviewRoute(path: string, search: string): boolean {
  const normalizedPath = normalizeTrackingPath(path).toLowerCase();
  const params = new URLSearchParams(search);
  return ['preview', 'previewSnapshot', 'previewProgram'].some(key => params.has(key)) &&
    (/^\/session\/[^/]+$/.test(normalizedPath) || normalizedPath === '/freestyle');
}

export function getJourneyRefType(journeyRef: string | null | undefined): 'uuid' | 'slug' | 'missing' {
  if (!journeyRef) return 'missing';
  return UUID_RE.test(journeyRef) ? 'uuid' : 'slug';
}
